import React, { useState, useCallback } from 'react'
import { Input } from 'reactstrap';
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";

const libraries = ["places"];

const GoogleAutoComplete = ({
    value,
    onChange,
    onPlaceSelected,
    placeholder = "Address 1",
    ...inputProps
}) => {
    const [autocomplete, setAutocomplete] = useState(null);

    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries,
    });

    const handleLoad = useCallback((auto) => {
        setAutocomplete(auto);
    }, []);

    const handlePlaceChanged = useCallback(() => {
        if (!autocomplete) return;

        const place = autocomplete.getPlace();

        // Let parent know a place was chosen (full Google place object)
        if (onPlaceSelected) {
            onPlaceSelected(place);
        }

    }, [autocomplete, onPlaceSelected, onChange]); 
    
   if (loadError) {
        return (
            <input
                type="text"
                disabled
                placeholder="Failed to load address autocomplete"
                {...inputProps}
            />
        );
    } 

    // Don't render GoogleAutocomplete until google is truly ready
    const googleReady =
        isLoaded &&
        typeof window !== "undefined" &&
        window.google &&
        window.google.maps;

    if (!googleReady) {
        return (
            <input
                type="text"
                disabled
                placeholder="Loading address autocomplete..."
                {...inputProps}
            />
        );
    }

    return (
        <Autocomplete 
        onLoad={handleLoad} 
        onPlaceChanged={handlePlaceChanged}
        fields={["address_components", "geometry", "formatted_address"]}>
            <input         
            type="text"
            value={value || ""}
            onChange={(e) => onChange && onChange(e.target.value)}
            placeholder={placeholder}
            {...inputProps}
            />
        </Autocomplete>
    )
}

export default GoogleAutoComplete